export default __webpack_public_path__ + "static/media/Icon6.09b7f373.svg";